import { DeleteOutlined } from "@ant-design/icons";
import { Button, Popconfirm } from "antd";
import {
  QuestionRemove,
  Cancel,
  Delete,
} from "shared/constants/define-localization";
import { CoreResource, t } from "shared/plugins/localization";
import {
  ThemeTemplateItem,
  ThemeTypeText,
} from "states/theme-template/theme-template.models";

export interface IThemeTemplateBasicProps {
  model: ThemeTemplateItem;
  onDelete: () => void;
}

export function ThemeTemplateBasic(props: IThemeTemplateBasicProps) {
  const { model, onDelete } = props;
  return (
    <div>
      <b>
        {model.name} - {ThemeTypeText[model.type]}
      </b>{" "}
      <Popconfirm
        placement="topLeft"
        onConfirm={onDelete}
        title={"Bạn có muốn xóa không ?"}
        okText="Đồng ý"
        cancelText={"Hủy"}
      >
        <Button danger icon={<DeleteOutlined />}>
          Xóa
        </Button>
      </Popconfirm>
    </div>
  );
}
